import React from 'react';
const steps = [{
  num: '01',
  title: 'Request a Quote',
  desc: "Contact us with details of your mission. We'll provide a straightforward, transparent estimate."
}, {
  num: '02',
  title: 'We Deploy',
  desc: 'Our squad arrives on-site, fully equipped and ready to execute the cleanup efficiently.'
}, {
  num: '03',
  title: 'Mission Accomplished',
  desc: 'We clear the zone, sweep the area, and haul away the debris. Your site is secure and clean.'
}];
export function HowItWorks() {
  return <section id="process" className="py-24 bg-card border-y border-border" data-id="element-146">
      <div className="container mx-auto px-4" data-id="element-147">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-148">
          <h2 className="text-primary font-bold tracking-widest uppercase text-sm mb-3 flex items-center justify-center gap-2" data-id="element-149">
            <span className="w-8 h-[2px] bg-primary" data-id="element-150"></span>
            Standard Operating Procedure
            <span className="w-8 h-[2px] bg-primary" data-id="element-151"></span>
          </h2>
          <h3 className="font-heading font-black text-4xl md:text-5xl uppercase tracking-tight" data-id="element-152">
            How We Operate
          </h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-153">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-[2px] bg-border z-0" data-id="element-154" />

          {steps.map((step, index) => <div key={index} className="relative z-10 flex flex-col items-center text-center" data-id="element-155">
              <div className="w-24 h-24 rounded-full bg-background border-4 border-card flex items-center justify-center mb-6 shadow-xl relative" data-id="element-156">
                <div className="absolute inset-0 rounded-full border border-primary/30 animate-[spin_10s_linear_infinite]" data-id="element-157" />
                <span className="font-heading font-black text-3xl text-primary" data-id="element-158">
                  {step.num}
                </span>
              </div>
              <h4 className="font-heading font-bold text-2xl uppercase tracking-wide mb-3" data-id="element-159">
                {step.title}
              </h4>
              <p className="text-muted-foreground font-medium max-w-sm" data-id="element-160">
                {step.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}